/**
 * Liste des classes / niveaux (pré-remplie).
 * Format : "Bachelor 1 (BA1)" pour clarté et complétude.
 * Les entrées ajoutées par validation de demandes sont en Firestore (collection classes).
 */

export const DEFAULT_CLASSES = [
  'Autre',
  // Bachelor
  'Bachelor 1 (BA1)',
  'Bachelor 2 (BA2)',
  'Bachelor 3 (BA3)',
  // Master
  'Master 1 (M1)',
  'Master 2 (M2)',
  // Cycles / préparatoire
  'Préparatoire',
  'Cycle 1',
  'Cycle 2',
  'Cycle 3',
  'Cycle spécialisé',
  // Autres niveaux courants
  'Diplôme d\'études musicales (DEM)',
  'Certificat d\'études musicales (CEM)',
  '1re année',
  '2e année',
  '3e année',
  '4e année',
  '5e année',
  'Terminale option musique',
]
